import { 
  FETCH_RANKED_ROUNDS, FETCH_RANKED_ROUNDS_SUCCESS, FETCH_RANKED_ROUNDS_FAILURE,
  SUBMIT_RANKED_BOOKING, SUBMIT_RANKED_BOOKING_SUCCESS, SUBMIT_RANKED_BOOKING_FAILURE,
  FETCH_LEADERBOARD, FETCH_LEADERBOARD_SUCCESS, FETCH_LEADERBOARD_FAILURE,
  FETCH_USER_PREDICTIONS, FETCH_USER_PREDICTIONS_SUCCESS, FETCH_USER_PREDICTIONS_FAILURE,
  FETCH_CURRENT_RANKED_ROUND, FETCH_CURRENT_RANKED_ROUND_SUCCESS, FETCH_CURRENT_RANKED_ROUND_FAILURE,
  FETCH_RANKED_BOOKINGS_LEADERBOARD, FETCH_RANKED_BOOKINGS_LEADERBOARD_SUCCESS, FETCH_RANKED_BOOKINGS_LEADERBOARD_FAILURE
} from "../types/competitionTypes";

const INITIAL_STATE = {
  rankedRounds: [],
  leaderboard: {},
  userPredictions: [],
  currentRankedRound: null,
  nextRankedRound: null,
  isLoading: false,
  error: null,
};

const competitionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RANKED_ROUNDS:
    case SUBMIT_RANKED_BOOKING:
    case FETCH_LEADERBOARD:
    case FETCH_USER_PREDICTIONS:
    case FETCH_CURRENT_RANKED_ROUND:
    case FETCH_RANKED_BOOKINGS_LEADERBOARD:
      return { ...state, isLoading: true, error: null };

    case FETCH_RANKED_ROUNDS_SUCCESS:
      return { ...state, rankedRounds: action.payload, isLoading: false };

    case SUBMIT_RANKED_BOOKING_SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        currentRankedRound: { 
            ...state.currentRankedRound, 
            hasPredicted: true 
        } 
      };

    case FETCH_LEADERBOARD_SUCCESS:
      return { ...state, leaderboard: action.payload, isLoading: false };

    case FETCH_USER_PREDICTIONS_SUCCESS:
      return { ...state, userPredictions: action.payload, isLoading: false };

    case FETCH_CURRENT_RANKED_ROUND_SUCCESS:
      return { ...state, currentRankedRound: action.payload.current, nextRankedRound: action.payload.next, isLoading: false };

    case FETCH_RANKED_BOOKINGS_LEADERBOARD_SUCCESS:
      return { ...state, leaderboard: action.payload, isLoading: false };

    case FETCH_RANKED_ROUNDS_FAILURE:
    case SUBMIT_RANKED_BOOKING_FAILURE:
    case FETCH_LEADERBOARD_FAILURE:
    case FETCH_USER_PREDICTIONS_FAILURE:
    case FETCH_CURRENT_RANKED_ROUND_FAILURE:
    case FETCH_RANKED_BOOKINGS_LEADERBOARD_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default competitionReducer;
